import { render } from "./Tab1.vue?vue&type=template&id=ec963d22&bindings={}"
import script from "./Tab1.vue?vue&type=script&lang=ts"
export * from "./Tab1.vue?vue&type=script&lang=ts"
script.render = render

export default script